var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('i',{class:_vm.fvalue,style:({ 'color': _vm.fColor, 'font-size': _vm.ffSize }),attrs:{"title":_vm.titleh},on:{"click":_vm.handleClick}},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }